import React from 'react';
import './DimensionGrid.css';
import { ACCELERATORS, BRAKES, racePressure, riskLevel, trendMeaning } from '../utils/dimensions';
import PixelIcon from './PixelIcon';

const SEGMENTS = 12;

function DimensionCard({ dimKey, dim }) {
  const risk = riskLevel(racePressure(dimKey, dim.value));
  const trend = trendMeaning(dimKey, dim.trend);
  const filled = Math.round((dim.value / 3) * SEGMENTS);

  return (
    <article className="dimension-card pixel-border-thin">
      <div className="dimension-header">
        <h3 className="dimension-name">{dim.name}</h3>
        <div className={`dimension-value ${risk.className}`}>{dim.value.toFixed(1)}</div>
      </div>

      <div className="dimension-meta">
        <span className={`risk-chip ${risk.className}`}>{risk.label} RISK</span>
        <span className="dimension-trend">
          <span className={`trend-icon ${trend.className}`}>{trend.icon}</span>
          <span className="text-secondary">{dim.trend}</span>
        </span>
      </div>

      <div
        className="dimension-bar"
        role="meter"
        aria-label={`${dim.name}: ${dim.value.toFixed(2)} out of 3`}
        aria-valuemin={0}
        aria-valuemax={3}
        aria-valuenow={dim.value}
      >
        {Array.from({ length: SEGMENTS }, (_, i) => (
          <span
            key={i}
            className={`segment ${i < filled ? 'on' : ''}`}
            style={i < filled ? { background: risk.color } : undefined}
          />
        ))}
      </div>

      <p className="dimension-description">{dim.description}</p>

      <ul className="signals-list" aria-label="Key signals">
        {dim.signals.map((signal, idx) => (
          <li key={idx} className="signal-item">{signal}</li>
        ))}
      </ul>
    </article>
  );
}

function DimensionGroup({ title, hint, keys, dimensions }) {
  const present = keys.filter(key => dimensions[key]);
  if (present.length === 0) return null;
  return (
    <div className="dimension-group">
      <div className="group-header">
        <h3 className="group-title">{title}</h3>
        <span className="group-hint">{hint}</span>
      </div>
      <div className="dimension-grid">
        {present.map(key => (
          <DimensionCard key={key} dimKey={key} dim={dimensions[key]} />
        ))}
      </div>
    </div>
  );
}

function DimensionGrid({ dimensions }) {
  return (
    <section className="dimension-grid-container" aria-labelledby="dimensions-title">
      <h2 id="dimensions-title" className="section-title glow-text">
        <span className="title-icon"><PixelIcon name="target" size={18} /></span>
        MONITORING DIMENSIONS
      </h2>

      <DimensionGroup
        title="Accelerators"
        hint="A high value pushes toward the race"
        keys={ACCELERATORS}
        dimensions={dimensions}
      />
      <DimensionGroup
        title="Brakes"
        hint="A high value slows the race down: low is the warning sign"
        keys={BRAKES}
        dimensions={dimensions}
      />
    </section>
  );
}

export default DimensionGrid;
